export default import.meta.ROLLDOWN_FILE_URL_GgifG4jXtHktadHRQ_fyew